module.exports = __webpack_public_path__ + "img/product_forsmax.95495135.jpg";